import { type SVGProps } from "react";
const IconNavThemes = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="-2 0 17 17"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.428 2.184H9.92v-.675c0-.218-.238-.317-.456-.317h-1.17C8.014.398 7.32.002 6.526.002a1.805 1.805 0 0 0-1.765 1.19H3.61c-.218 0-.437.099-.437.317v.675H1.667A1.686 1.686 0 0 0 0 3.79v11.368c0 .873.794 1.508 1.667 1.508h9.76c.874 0 1.667-.635 1.667-1.508V3.79a1.686 1.686 0 0 0-1.666-1.607Zm-7.46-.199h1.091a.437.437 0 0 0 .377-.357A1.15 1.15 0 0 1 6.527.735c.52.016.962.385 1.072.893a.436.436 0 0 0 .396.357h1.131v1.587H3.968V1.985Zm8.333 13.174c0 .436-.437.714-.873.714H1.667c-.437 0-.873-.278-.873-.714V3.79a.893.893 0 0 1 .873-.814h1.507V3.99a.417.417 0 0 0 .437.377h5.853a.436.436 0 0 0 .456-.377V2.977h1.508c.456.009.832.36.873.814v11.368Z"
    />
    <path
      fill="currentColor"
      d="M5.02 8.87a.397.397 0 0 0-.556-.02l-1.27 1.21-.535-.556a.397.397 0 0 0-.556-.02.417.417 0 0 0 0 .576l.813.833c.07.08.173.123.278.12a.396.396 0 0 0 .278-.12l1.547-1.468a.377.377 0 0 0 0-.555ZM10.713 9.723H6.15a.397.397 0 1 0 0 .793h4.563a.397.397 0 0 0 0-.793ZM5.02 5.695a.397.397 0 0 0-.556-.02l-1.27 1.21-.535-.555a.397.397 0 0 0-.556-.02.417.417 0 0 0 0 .576l.813.833c.07.079.173.122.278.119a.397.397 0 0 0 .278-.119l1.547-1.468a.377.377 0 0 0 0-.556ZM10.713 6.548H6.15a.397.397 0 1 0 0 .794h4.563a.397.397 0 0 0 0-.794ZM5.02 12.044a.397.397 0 0 0-.556-.02l-1.27 1.21-.535-.555a.397.397 0 0 0-.556-.02.417.417 0 0 0 0 .575l.813.834c.07.079.173.122.278.119a.397.397 0 0 0 .278-.12L5.019 12.6a.377.377 0 0 0 0-.556ZM10.713 12.897H6.15a.397.397 0 0 0 0 .794h4.563a.397.397 0 1 0 0-.794Z"
    />
  </svg>
);
export default IconNavThemes;
